import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Flex, Stack, Text, useDisclosure } from '../../../../vanilla'
import { useBasketStore, useOrderStore } from '../../../../store/hooks/useStore'
import { OrderSummaryProgressBars } from '../../../order-summary/progress-bars'
import { CollapsablePanel } from '../../../collapsable-panel'
import { OrderSummary } from '../../../order-summary'
import { ChevronDownIcon } from '../../../icons'
import { ExitOrderEditModeModal } from '../../../edit-order-exit-mode-modal'
import { useCarrierBag } from '../../../order-summary/use-carrier-bag'
import { BasketToCheckoutButton } from '../../../../pages/cart/partials/basket-to-checkout-button'
import useNavigation from '../../../../hooks/use-navigation'
import { ShoppingTotal } from '../../../order-summary/shopping-total'

export const DrawerTotals = observer(() => {
  const exitEditModeModal = useDisclosure()
  const { editMode } = useOrderStore()
  const basketStore = useBasketStore()
  const { basket } = basketStore
  const { includeBag, setIncludeBag } = useCarrierBag()
  const navigate = useNavigation()

  const handleCheckoutButtonClick = () => {
    navigate('/basket')
  }

  return (
    <>
      <Stack spacing="0px" bg="white">
        <CollapsablePanel
          width="full"
          defaultOpen={false}
          panelContent={basket &&
            <OrderSummary
              tabledMode
              showOrderTotal={false}
              showItemsCount={false}
              paddingBottom="12px"
              borderColor="gray200"
              includeBag={includeBag}
              setIncludeBag={setIncludeBag}
            />
          }
        >
          {({ onToggle, isOpen }) => {
            return (
              <Flex
                onClick={() => {
                  onToggle()
                }}
                cursor="pointer"
                align="center"
                justify="space-between"
                padding="16px"
                width="full"
                borderTop="1px"
                borderBottom={isOpen ? "1px" : undefined}
                borderColor="gray200"
              >
                <Text variant="text3">Shopping total</Text>
                <Flex align="center" gap="8px">
                  <ShoppingTotal inDrawer={true} />
                  <ChevronDownIcon
                    boxSize="16px"
                    data-test-selector="basket-total-chevron-icon"
                    style={{ transform: isOpen ? 'rotate(180deg)' : undefined }}
                  />
                </Flex>
              </Flex>
            )
          }}
        </CollapsablePanel>
        {basket && !editMode && (
          <OrderSummaryProgressBars border={true}/>
        )}
        <Stack paddingX="20px" paddingY="12px" spacing="8px" borderTop="1px" borderColor="gray200">          
          <BasketToCheckoutButton
            width="full"
            display="inline-flex"
            data-test-selector="checkout-securely-button"
            checkoutButtonText='Checkout Securely'
            onClick={() => handleCheckoutButtonClick()}
          />
          {editMode && (
            <Button
              variant="primary"
              data-test-selector="discard-changes-button"
              width="full"
              size="sm"
              onClick={() => {
                exitEditModeModal.onOpen()
              }}
            >
              Discard Changes and Exit
            </Button>
          )}
        </Stack>
      </Stack>
      <ExitOrderEditModeModal {...exitEditModeModal} />
    </>
  )
})
